import React, { memo } from 'react';
import BankAccountRow from './BankAccountRow';
import ConnectedAccountRow from './ConnectedAccountRow';
const ConnectedAccountOrBankAccountRow = ({ account, setFrom, onScroll, scrollValue, }) => {
    if ('bankConnectionId' in account) {
        return <BankAccountRow account={account} scrollValue={scrollValue} onScroll={onScroll} setFrom={setFrom}/>;
    }
    return <ConnectedAccountRow account={account}/>;
};
export default memo(ConnectedAccountOrBankAccountRow);
